import { get } from 'lodash';

export const SystemSettingsActions = {
  getSystemConfigProp(prop) {
    return get(this.state.systemConfig, prop);
  },
};
